import Crud from '../views/Unit/Crud'
import Entity from '../views/Unit/Add'

let routes = {
    path: '/units',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/units/add',
            name: 'NewUnit',
            component: Entity,
            meta: {
                perfil_id: ['1', '6'] // Administradores e gestores de empresa
            }
        },
        {
            path: '/units/edit/:id?',
            name: 'EditUnit',
            component: Entity,
            meta: {
                perfil_id: ['1', '6'] // Administradores e gestores de empresa
            }
        },
        {
            path: '/units',
            name: 'list-units',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Unidades',
                breadcrumb: [
                    {
                        text: 'Unidades',
                        active: true,
                    },
                ],
                perfil_id: ['1', '6', '7'] // Admin, Gestor da Empresa e Gestor Operacional (somente leitura da lista)
            },
        },
    ]
};


export default routes
